import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../../utils/seo';
import { useSmoothScroll } from '../../hooks/useSmoothScroll';

export default function HomePage() {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);
  useSmoothScroll();

  useSEO({
    title: '京都・滋賀の格安防犯カメラ販売・設置工事ならネクストステージ',
    description: '京都府・滋賀県専門の格安防犯カメラ販売・設置工事サービス。地域密着で安心の施工を提供。55,000円（税込）〜の格安プランあり。',
    keywords: '防犯カメラ 京都 格安, 防犯カメラ 京都, 防犯カメラ 滋賀 格安, 防犯カメラ 滋賀',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          '@id': `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
          url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
          name: '京都・滋賀の格安防犯カメラ販売・設置工事｜ネクストステージ',
          description: '京都府・滋賀県専門の格安防犯カメラ販売・設置工事サービス。地域密着で安心の施工を提供。55,000円（税込）〜の格安プランあり。',
          inLanguage: 'ja',
          isPartOf: {
            '@type': 'WebSite',
            '@id': `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#website`,
            url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
            name: 'ネクストステージ',
            inLanguage: 'ja'
          },
          breadcrumb: {
            '@type': 'BreadcrumbList',
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'ホーム',
                item: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
              }
            ]
          }
        },
        {
          '@type': 'LocalBusiness',
          '@id': `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#business`,
          name: 'Next stage（ネクストステージ）',
          description: '京都府・滋賀県専門の格安防犯カメラ販売・設置工事サービス。地域密着で安心の施工を提供。',
          url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
          telephone: '080-2527-8110',
          priceRange: '¥¥',
          image: 'https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/b20bf12da98b13bf6586d3e638cf3b35.jpeg',
          address: {
            '@type': 'PostalAddress',
            postalCode: '542-0083',
            addressCountry: 'JP',
            addressRegion: '大阪府',
            addressLocality: '大阪市中央区',
            streetAddress: '東心斎橋１丁目９-１９-３０７'
          },
          geo: {
            '@type': 'GeoCoordinates',
            latitude: 34.6937,
            longitude: 135.5023
          },
          openingHoursSpecification: {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
            opens: '09:00',
            closes: '17:00'
          },
          areaServed: [
            { '@type': 'State', name: '京都府' },
            { '@type': 'State', name: '滋賀県' },
            { '@type': 'State', name: '大阪府' },
            { '@type': 'State', name: '奈良県' },
            { '@type': 'State', name: '兵庫県' },
            { '@type': 'State', name: '和歌山県' }
          ],
          hasOfferCatalog: {
            '@type': 'OfferCatalog',
            name: '防犯カメラ設置サービス',
            itemListElement: [
              {
                '@type': 'Offer',
                itemOffered: {
                  '@type': 'Service',
                  name: '格安防犯カメラ販売・設置工事セットプラン',
                  description: '高性能無線防犯カメラの販売＋設置工事＋スマホ設定込み'
                },
                price: '55000',
                priceCurrency: 'JPY',
                priceSpecification: {
                  '@type': 'PriceSpecification',
                  price: '55000',
                  priceCurrency: 'JPY',
                  valueAddedTaxIncluded: true
                }
              }
            ]
          }
        },
        {
          '@type': 'FAQPage',
          '@id': `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/#faq`,
          mainEntity: [
            {
              '@type': 'Question',
              name: '一般家庭に防犯カメラは必要ですか?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '以前は防犯カメラというと「お店や会社が使うもの」というイメージがありましたが、今では京都府・滋賀県の一般家庭でも格安で導入できるようになっています。実は「うちは大丈夫」と思っている家庭ほど、空き巣や不審者に狙われやすいという傾向があります。防犯カメラを設置することで、不審者への抑止効果が期待でき、万が一の際には証拠としても役立ちます。また、共働き世帯や高齢者世帯では、外出先から自宅の様子を確認できることで大きな安心感につながります。まずは1台から始めることもできますので、ご家庭の状況に合わせて検討されることをおすすめします。'
              }
            },
            {
              '@type': 'Question',
              name: '費用はどのくらいかかりますか?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '京都・滋賀エリアでの防犯カメラ設置費用は、機種や台数、設置場所によって異なりますが、格安プランは55,000円（税込）〜ご用意しております。最近では、高性能でありながら地域最安値クラスの価格帯のカメラも多数ございます。まずはお客様のご予算やご要望をお聞きした上で、最適なプランをご提案させていただきます。'
              }
            },
            {
              '@type': 'Question',
              name: 'なるべく安く済ませたい場合はどうすればいいですか?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'ご予算に合わせた格安プランのご提案が可能です。例えば、まずは玄関など重要な場所に1台だけ設置し、後から必要に応じて追加していく方法もあります。また、機能を絞ったシンプルなモデルを選ぶことで、コストを抑えることもできます。お客様がカメラ本体をご自身で購入される場合は、設置・設定作業のみのご依頼も承っております。京都・滋賀エリアで無理のない範囲で始められるよう、まずはご相談ください。'
              }
            },
            {
              '@type': 'Question',
              name: 'カメラを持ち込みたい場合でも対応してもらえますか?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'はい、お客様がご自身で購入されたカメラの設置・設定作業のみのご依頼も承っております。京都府・滋賀県内であれば、インターネットなどで購入されたカメラでも、設置場所の確認から配線工事、ネットワーク設定、スマホでの確認方法まで、しっかりとサポートいたします。ただし、機種によっては設置が難しい場合や、十分な性能が発揮できない場合もございますので、事前にご相談いただけるとスムーズです。'
              }
            },
            {
              '@type': 'Question',
              name: '設置・設定作業のみ依頼することはできますか?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'もちろん可能です。カメラ本体はお客様がご用意され、設置工事と初期設定のみを弊社にお任せいただくことができます。京都府・滋賀県全域で対応しております。設置後は、スマホでの確認方法や操作方法についても丁寧にご説明いたしますので、機械が苦手な方でも安心してご利用いただけます。'
              }
            },
            {
              '@type': 'Question',
              name: 'スマホで確認できますか?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'はい、最近の防犯カメラはほとんどがスマホでの確認に対応しています。専用アプリをインストールすることで、外出先からでもリアルタイムで自宅の様子を確認できます。映像の確認だけでなく、録画映像の再生や、カメラによっては音声での呼びかけも可能です。設置後は、スマホでの確認方法や操作方法についても丁寧にご説明いたしますので、機械が苦手な方でも安心してご利用いただけます。ご家族全員のスマホに設定することも可能ですので、家族みんなで見守ることができます。'
              }
            },
            {
              '@type': 'Question',
              name: 'トラブル時に証拠として役立ちますか?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'はい、防犯カメラの映像は様々なトラブルの際に有力な証拠として役立ちます。空き巣や窃盗事件の際には、犯人の特徴や行動パターンが記録されており、警察の捜査に大きく貢献します。また、近隣トラブルや事故の際にも、映像が客観的な証拠となることで不要な誤解を防ぎ、円満な解決につながります。記録されているという事実自体がトラブルの抑止効果にもつながります。'
              }
            },
            {
              '@type': 'Question',
              name: '要望通り柔軟に対応してもらえますか?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'はい、お客様のご要望に合わせて柔軟に対応いたします。京都府・滋賀県を中心に、設置場所や台数、予算、機能など、お客様それぞれのご事情やご希望は異なりますので、まずはしっかりとお話を伺った上で、最適な格安プランをご提案させていただきます。無理な提案や押し売りは一切いたしませんので、安心してご相談いただけます。'
              }
            }
          ]
        }
      ]
    }
  });

  const toggleFaq = (index: number) => {
    setOpenFaqIndex(openFaqIndex === index ? null : index);
  };

  const faqs = [
    {
      question: '一般家庭に防犯カメラは必要ですか?',
      answer: '以前は防犯カメラというと「お店や会社が使うもの」というイメージがありましたが、今では京都府・滋賀県の一般家庭でも格安で導入できるようになっています。実は「うちは大丈夫」と思っている家庭ほど、空き巣や不審者に狙われやすいという傾向があります。防犯カメラを設置することで、不審者への抑止効果が期待でき、万が一の際には証拠としても役立ちます。また、共働き世帯や高齢者世帯では、外出先から自宅の様子を確認できることで大きな安心感につながります。まずは1台から始めることもできますので、ご家庭の状況に合わせて検討されることをおすすめします。'
    },
    {
      question: '防犯意識が高くない家庭でも意味がありますか?',
      answer: '防犯意識の高低に関わらず、カメラがあるだけで不審者への抑止効果は十分に期待できます。実際、空き巣などは「防犯対策をしていない家」を狙う傾向があるため、カメラが見えるだけでも大きな効果があります。京都府・滋賀県でも近年、住宅への不審者侵入が増加傾向にあります。格安でも高性能な機種が揃っています。'
    },
    {
      question: '設置することでどんな安心感が得られますか?',
      answer: '防犯カメラを設置すると、まず「見守られている」という安心感が生まれます。外出中でもスマホから自宅の様子を確認できるため、留守中の不安が大きく軽減されます。また、お子様の帰宅確認や高齢の家族の見守りにも活用でき、家族全体の安心につながります。京都・滋賀の住宅街や店舗でも設置場所を選びやすい点も特長の一つです。'
    },
    {
      question: '費用はどのくらいかかりますか?',
      answer: '京都・滋賀エリアでの防犯カメラ設置費用は、機種や台数、設置場所によって異なりますが、格安プランは55,000円（税込）〜ご用意しております。最近では、高性能でありながら地域最安値クラスの価格帯のカメラも多数ございます。設置工事費用も含めて、まずはお客様のご予算やご要望をお聞きした上で、最適なプランをご提案させていただきます。'
    },
    {
      question: 'なるべく安く済ませたい場合はどうすればいいですか?',
      answer: 'ご予算に合わせた格安プランのご提案が可能です。例えば、まずは玄関など重要な場所に1台だけ設置し、後から必要に応じて追加していく方法もあります。また、機能を絞ったシンプルなモデルを選ぶことで、コストを抑えることもできます。お客様がカメラ本体をご自身で購入される場合は、設置・設定作業のみのご依頼も承っております。京都・滋賀エリアで無理のない範囲で始められるよう、まずはご相談ください。'
    },
    {
      question: 'カメラを持ち込みたい場合でも対応してもらえますか?',
      answer: 'はい、お客様がご自身で購入されたカメラの設置・設定作業のみのご依頼も承っております。京都府・滋賀県内であれば、インターネットなどで購入されたカメラでも、設置場所の確認から配線工事、ネットワーク設定、スマホでの確認方法まで、しっかりとサポートいたします。ただし、機種によっては設置が難しい場合や、十分な性能が発揮できない場合もございますので、事前にご相談いただけるとスムーズです。'
    },
    {
      question: '設置・設定作業のみ依頼することはできますか?',
      answer: 'もちろん可能です。カメラ本体はお客様がご用意され、設置工事と初期設定のみを弊社にお任せいただくことができます。京都府・滋賀県全域で対応しております。設置後は、スマホでの確認方法や操作方法についても丁寧にご説明いたしますので、機械が苦手な方でも安心してご利用いただけます。'
    },
    {
      question: 'スマホで確認できますか?',
      answer: 'はい、最近の防犯カメラはほとんどがスマホでの確認に対応しています。専用アプリをインストールすることで、外出先からでもリアルタイムで自宅の様子を確認できます。映像の確認だけでなく、録画映像の再生や、カメラによっては音声での呼びかけも可能です。設置後は、スマホでの確認方法や操作方法についても丁寧にご説明いたしますので、機械が苦手な方でも安心してご利用いただけます。ご家族全員のスマホに設定することも可能ですので、家族みんなで見守ることができます。'
    },
    {
      question: 'トラブル時に証拠として役立ちますか?',
      answer: 'はい、防犯カメラの映像は様々なトラブルの際に有力な証拠として役立ちます。空き巣や窃盗事件の際には、犯人の特徴や行動パターンが記録されており、警察の捜査に大きく貢献します。また、近隣トラブルや事故の際にも、映像が客観的な証拠となることで不要な誤解を防ぎ、円満な解決につながります。記録されているという事実自体がトラブルの抑止効果にもつながります。'
    },
    {
      question: '要望通り柔軟に対応してもらえますか?',
      answer: 'はい、お客様のご要望に合わせて柔軟に対応いたします。京都府・滋賀県を中心に、設置場所や台数、予算、機能など、お客様それぞれのご事情やご希望は異なりますので、まずはしっかりとお話を伺った上で、最適な格安プランをご提案させていただきます。無理な提案や押し売りは一切いたしませんので、安心してご相談いただけます。'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white shadow-sm fixed top-0 left-0 right-0 z-50">
        <div className="bg-teal-700 text-white">
          <nav className="max-w-7xl mx-auto px-4">
            <ul className="flex flex-wrap items-center justify-center gap-6 py-3 text-sm">
              <li>
                <a href="#camera-features" className="hover:text-teal-200 whitespace-nowrap">実績の一部紹介</a>
              </li>
              <li>
                <a href="#achievements" className="hover:text-teal-200 whitespace-nowrap">今どきの防犯カメラの機能</a>
              </li>
              <li>
                <a href="#use-cases" className="hover:text-teal-200 whitespace-nowrap">防犯カメラ活用事例</a>
              </li>
              <li>
                <a href="#faq-section" className="hover:text-teal-200 whitespace-nowrap">よくあるご質問(Q&A)</a>
              </li>
              <li>
                <Link to="/company#company-info" className="hover:text-teal-200 whitespace-nowrap">会社概要</Link>
              </li>
            </ul>
          </nav>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex-shrink-0">
              <Link to="/" className="flex items-center gap-3">
                <img 
                  src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/b20bf12da98b13bf6586d3e638cf3b35.jpeg" 
                  alt="Next stage ロゴ" 
                  className="h-12 w-auto object-contain"
                  fetchPriority="high"
                  decoding="sync"
                  width="120"
                  height="48"
                />
                <span className="text-2xl font-bold text-teal-700 m-0 p-0 leading-none">京都・滋賀の格安防犯カメラ販売・設置工事ならネクストステージ</span>
              </Link>
            </div>
            
            <div className="hidden lg:flex items-center gap-6">
              <div className="flex items-center gap-4">
                <div className="text-right">
                  <a
                    href="tel:08025278110"
                    className="text-2xl font-bold text-teal-700"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    TEL. 080-2527-8110
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Breadcrumb */}
      <div className="bg-gray-50 mt-32 lg:mt-28">
        <div className="max-w-7xl mx-auto px-4 py-3 text-sm text-gray-600">
          <Link to="/" className="hover:text-gray-900">ホーム</Link>
          <span className="mx-2">&gt;</span>
          <span className="text-gray-900">京都・滋賀の格安防犯カメラ販売・設置工事</span>
        </div>
      </div>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 py-8">
        {/* Page Title */}
        <h1 className="text-4xl font-bold text-gray-900 mb-6">京都・滋賀の格安防犯カメラ販売・設置工事</h1>

        {/* Price Section */}
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-900 leading-relaxed whitespace-nowrap">
            機器の選定から施工までプロがトータルサポート。地域に根ざした「見える安心」を。
          </h2>
        </div>

        {/* Hero Image */}
        <div className="mb-12">
          <img
            src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/d337293da191782942c52472feda0df5.jpeg"
            alt="京都・滋賀の格安防犯カメラ設置工事"
            className="w-full h-auto rounded-lg object-cover object-center"
            fetchPriority="high"
            decoding="sync"
            width="1200"
            height="600"
          />
        </div>

        {/* Introduction Section */}
        <section className="mb-16 bg-gradient-to-br from-teal-50 via-emerald-50 to-cyan-50 p-12 rounded-2xl">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 leading-relaxed whitespace-nowrap">
              京都府・滋賀県を中心に、格安防犯カメラの販売から設置までお任せください。
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              社会環境が変化する中、予期せぬトラブルへの備えは不可欠です。<br />
              ネクストステージは、<strong>京都府・滋賀県</strong>を中心に、<strong>格安</strong>の防犯カメラ販売と確かな設置施工を承っております。
            </p>
            
            <div className="bg-white rounded-xl p-8 shadow-md mb-6">
              <h3 className="text-2xl font-bold text-teal-700 mb-4 text-center">【格安！販売＋工事セットプラン：55,000円（税込）〜】</h3>
              <ul className="space-y-3 text-gray-700">
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl flex-shrink-0 mt-1"></i>
                  <span>高性能無線防犯カメラの「販売」</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl flex-shrink-0 mt-1"></i>
                  <span><strong>京都・滋賀</strong>での迅速な「設置工事」</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl flex-shrink-0 mt-1"></i>
                  <span>スマホでの遠隔管理・録画設定（設定込み）</span>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-checkbox-circle-fill text-teal-600 text-xl flex-shrink-0 mt-1"></i>
                  <span>専門スタッフによる丁寧な操作説明</span>
                </li>
              </ul>
            </div>
            
            <p className="text-lg text-gray-700 leading-relaxed text-center">
              地域密着型の迅速な対応で、お客様の予算や用途に合わせた<strong>格安</strong>の最適なセキュリティをご提案します。初めての導入も安心してお任せください。
            </p>
          </div>
          
          <div className="mt-12 max-w-4xl mx-auto">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img 
                src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/7b1c04f26d4f4c0e93702391aa381639.jpeg" 
                alt="京都・滋賀での格安防犯カメラ設置実績" 
                className="w-full h-auto object-cover object-top"
                loading="lazy"
                decoding="async"
                width="800"
                height="500"
              />
            </div>
          </div>
        </section>

        {/* Service Introduction Section */}
        <section className="mb-16 bg-gradient-to-br from-green-50 to-teal-50 p-12 rounded-2xl">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center whitespace-nowrap">京都府・滋賀県の一般家庭・店舗向け格安防犯カメラ設置工事サービス</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl shadow-sm overflow-hidden hover:shadow-lg transition-shadow">
              <div className="h-48 overflow-hidden">
                <img src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/7f0db84ff202681a5fd5286bd0da5562.jpeg" alt="安心できる格安提案" className="w-full h-full object-cover object-top" loading="lazy" decoding="async" width="400" height="192" />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">安心できる格安提案</h3>
                <p className="text-gray-700 leading-relaxed text-sm">
                  これまでの<strong>京都府・滋賀県</strong>での防犯カメラ設置経験をもとに、住環境や利用目的に合った格安プランをご提案しています。<br />
                  台数や設置位置を必要以上に増やさず、効果と費用のバランスを重視。<br />
                  初めての方でも不安なく相談できる体制を整えています。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-sm overflow-hidden hover:shadow-lg transition-shadow">
              <div className="h-48 overflow-hidden flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/44a9f71dd2fc017b21f802548258f07a.jpeg"
                  alt="目的に合わせた、無理のないカメラ選定"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  decoding="async"
                  width="400"
                  height="192"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">目的に合わせた、無理のないカメラ選定</h3>
                <p className="text-gray-700 leading-relaxed text-sm">
                  防犯・見守り・トラブル対策など、目的は家庭や店舗ごとに異なります。<br />
                  機能や価格を比較しながら、必要なポイントだけを分かりやすく説明。<br />
                  高性能を押し付けるのではなく、<strong>格安</strong>で使いやすさを重視した提案を行います。
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-sm overflow-hidden hover:shadow-lg transition-shadow">
              <div className="h-48 overflow-hidden">
                <img
                  src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/e81c9b7b18a8b1673e943dc99b4e03e3.jpeg"
                  alt="生活や営業に配慮した柔軟な施工対応"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  decoding="async"
                  width="400"
                  height="192"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-4">生活や営業に配慮した柔軟な施工対応</h3>
                <p className="text-gray-700 leading-relaxed text-sm">
                  日中の立ち会いが難しい方や、営業時間への影響を避けたい場合にも配慮します。<br />状況に応じて時間帯や施工方法を調整。<br />
                  日常をできるだけ妨げず、安心して設置できる環境づくりを大切にしています。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Case Studies Section */}
        <section id="camera-features" className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">京都・滋賀での防犯カメラ設置実績の一部紹介</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-shadow border border-gray-100">
              <div className="h-64 overflow-hidden">
                <img src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/9959c84e57b90d482105edae84c7f44a.jpeg" alt="滋賀県での一般家庭の格安防犯カメラ設置事例" className="w-full h-full object-cover object-top" loading="lazy" decoding="async" width="600" height="256" />
              </div>
              <div className="p-6">
                <div className="text-sm text-teal-700 mb-2 font-semibold">設置場所:一般家庭(玄関上のベランダの壁)</div>
                <div className="text-lg font-bold text-gray-900 mb-3">滋賀県大津市 F様邸</div>
                <div className="mb-4">
                  <div className="text-sm font-bold text-gray-700 mb-2 flex items-center gap-2">
                    <i className="ri-error-warning-line text-amber-600"></i>
                    導入前の課題
                  </div>
                  <p className="text-sm text-gray-600">留守中の来訪者が分からず、不在時の不安を感じていた。近隣で空き巣被害があり、何か対策をしたいと考えていた。</p>
                </div>
                <div>
                  <div className="text-sm font-bold text-teal-700 mb-2 flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-teal-700"></i>
                    導入後の改善
                  </div>
                  <p className="text-sm text-gray-600">スマホで外出先から自宅の様子を確認できるようになり、安心感が大きく向上。不審者への抑止効果も実感している。格安で導入できたとご満足いただいています。</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-md overflow-hidden hover:shadow-xl transition-shadow border border-gray-100">
              <div className="h-64 overflow-hidden">
                <img src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/7b1c04f26d4f4c0e93702391aa381639.jpeg" alt="滋賀県での店舗の格安防犯カメラ設置事例" className="w-full h-full object-cover object-top" loading="lazy" decoding="async" width="600" height="256" />
              </div>
              <div className="p-6">
                <div className="text-sm text-teal-700 mb-2 font-semibold">設置場所:小売店舗(外壁)</div>
                <div className="text-lg font-bold text-gray-900 mb-3">滋賀県彦根市 コインランドリー</div>
                <div className="mb-4">
                  <div className="text-sm font-bold text-gray-700 mb-2 flex items-center gap-2">
                    <i className="ri-error-warning-line text-amber-600"></i>
                    導入前の課題
                  </div>
                  <p className="text-sm text-gray-600">駐車場が店舗の裏にあり、出入りする通路が車一台が通る程度のため、無断駐車が絶えない店舗でした。</p>
                </div>
                <div>
                  <div className="text-sm font-bold text-teal-700 mb-2 flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-teal-700"></i>
                    導入後の改善
                  </div>
                  <p className="text-sm text-gray-600">映像で状況を確認し適切な対応が可能に。数日同じ車が出入りし、長時間駐車していることが分かったため、無断駐車対応が確実に可能になりました。現在では無断駐車殆ど無くなりました。</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Troubles Section */}
        <section className="mb-16 bg-gradient-to-br from-amber-50 to-orange-50 p-10 rounded-2xl border border-orange-100">
          <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center">京都府・滋賀県で防犯カメラ設置をお考えの方へ<br />防犯カメラ設置で、こんなお悩みはありませんか？</h2>
          <ul className="space-y-3 max-w-3xl mx-auto">
            <li className="flex items-start gap-3">
              <i className="ri-checkbox-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
              <span className="text-gray-700">京都・滋賀の自宅や店舗、駐車場まわりに防犯カメラを設置したいが、どこに付ければいいのか分からない</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-checkbox-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
              <span className="text-gray-700">外出先からリアルタイムに自宅やお店の様子を確認したい</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-checkbox-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
              <span className="text-gray-700">留守中や夜間、営業時間外の状況を映像でしっかり確認できる環境を整えたい</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-checkbox-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
              <span className="text-gray-700">万が一のトラブル（盗難・いたずら等）に備えて、映像を記録として残しておきたい</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-checkbox-circle-fill text-orange-500 text-xl flex-shrink-0 mt-1"></i>
              <span className="text-gray-700">家族やスタッフ、お客様の安全を守りつつ、安心して過ごせる環境を作りたい</span>
            </li>
          </ul>
        </section>

        {/* Solution Section */}
        <section className="mb-16 bg-white border-2 border-cyan-100 p-10 rounded-2xl shadow-sm">
          <h3 className="text-xl font-bold text-gray-900 mb-4">京都府・滋賀県での防犯カメラ設置工事ならお任せください。<br />お客様のご要望に沿った、無理のないご提案をいたします。</h3>
          <p className="text-gray-700 leading-relaxed mb-4">
            当社では、<strong>京都府・滋賀県</strong>に特化した格安防犯カメラの設置工事・設定作業に対応しており、現地確認を重視した地域密着型の防犯カメラ設置工事を行っています。京都府・滋賀県全域に対応しています。
          </p>
          <p className="text-gray-700 leading-relaxed mb-4">
            これまでに<strong>京都府・滋賀県エリア</strong>で積み重ねてきた防犯カメラ設置の実績はまだ数十件と多くはありませんが、一件一件の現場にしっかり向き合い、建物環境やご利用状況に合わせた設置を大切にしてきました。
          </p>
          <p className="text-gray-700 leading-relaxed">
            市販カメラの持ち込み設置や、設置・設定作業のみのご相談など、「できるだけ格安で済ませたい」「必要な部分だけ頼みたい」といったご要望にも柔軟に対応しています。<strong>京都府・滋賀県</strong>で格安の防犯カメラ設置工事を検討されている方は、まずはお気軽にご相談ください。
          </p>
        </section>

        {/* Camera Features Section */}
        <section id="achievements" className="mb-16">
          <div className="mb-12">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <img 
                src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/3cdd3e19bc5cd8936235951fe8826174.jpeg" 
                alt="防犯カメラの機能" 
                className="w-full h-auto object-cover object-top"
                loading="lazy"
                decoding="async"
                width="1200"
                height="600"
              />
            </div>
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mb-4 text-center">京都・滋賀の暮らしと店舗を支える、今どきの防犯カメラ機能</h2>
          <p className="text-gray-700 text-center mb-12 max-w-4xl mx-auto leading-relaxed">
            防犯カメラは「監視するための機械」から、日常の安心や確認作業を支える身近なツールへと進化しています。京都府・滋賀県の一般家庭・一般店舗で役立つ代表的な機能をご紹介します。格安でも高性能な機種が揃っています。
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: '外出先から状況をチェック',
                icon: 'ri-smartphone-line',
                description: 'インターネット環境があれば、外出先からでも自宅や店舗の様子を確認できます。「今どうなっているか」をすぐに把握できるため、無駄な不安を感じにくくなります。京都・滋賀エリアで格安に導入できるカメラでも、この機能は標準搭載されています。',
                color: 'from-teal-50 to-cyan-50',
                iconColor: 'text-teal-700'
              },
              {
                title: '離れた場所でも操作が可能',
                icon: 'ri-remote-control-line',
                description: '設置した場所に行かなくても、設定変更や確認操作が行える機種があります。忙しい日常の中でも、必要なときに必要な操作ができる点が特長です。手間をかけずに管理できることは、長く使う上での大きなメリットです。',
                color: 'from-emerald-50 to-green-50',
                iconColor: 'text-emerald-700'
              },
              {
                title: '映像を振り返って確認できる',
                icon: 'ri-history-line',
                description: '映像が残ることで、「何があったのか」を後から落ち着いて確認できます。記憶に頼らず事実を確認できるため、トラブル時の負担を軽減できます。京都・滋賀の一般家庭・店舗での日常的な確認用途にもつながります。',
                color: 'from-cyan-50 to-blue-50',
                iconColor: 'text-cyan-700'
              },
              {
                title: '細かな部分まで見やすい映像',
                icon: 'ri-focus-3-line',
                description: '映像の鮮明さが向上したことで、状況が分かりやすくなっています。「何が写っているのか分からない」という不安を感じにくくなりました。格安プランでも高画質な機種をご用意しています。',
                color: 'from-blue-50 to-indigo-50',
                iconColor: 'text-blue-700'
              },
              {
                title: '音で気づける安心設計',
                icon: 'ri-volume-up-line',
                description: '映像だけでなく、音を通じて確認や対応ができる機能もあります。その場にいなくても状況を把握しやすく、抑止効果も期待できます。使い方次第で、見守り用途としても活用可能です。',
                color: 'from-green-50 to-teal-50',
                iconColor: 'text-green-700'
              },
              {
                title: '暗い時間帯でも確認しやすい',
                icon: 'ri-moon-line',
                description: '夜間や照明が少ない場所でも、周囲の様子を確認しやすくなっています。昼夜を問わず状況を把握できることは、防犯面だけでなく安心面でも重要です。京都・滋賀の住宅街や店舗でも設置場所を選びやすい点も特長の一つです。',
                color: 'from-indigo-50 to-purple-50',
                iconColor: 'text-indigo-700'
              }
            ].map((feature, index) => (
              <div key={index} className={`bg-gradient-to-br ${feature.color} rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow p-8`}>
                <div className="mb-6 flex items-center justify-center">
                  <div className="w-16 h-16 flex items-center justify-center bg-white rounded-full shadow-sm">
                    <i className={`${feature.icon} text-3xl ${feature.iconColor}`}></i>
                  </div>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-4 text-center">{feature.title}</h3>
                <p className="text-sm text-gray-700 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* Use Cases Section */}
        <section id="use-cases" className="mb-16">
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">防犯カメラは、防犯のためだけのものではありません</h2>
            <p className="text-gray-700 text-center max-w-4xl mx-auto leading-relaxed">
              防犯カメラの進化により、<strong>京都府・滋賀県</strong>の一般家庭や一般店舗でも防犯以外の目的で活用されるケースが増えています。留守中の見守り、業務効率の改善、トラブル防止など、様々な場面で安心と効率化につながる活用例をご紹介します。
            </p>
          </div>

          <div className="mb-16">
            <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">京都府・滋賀県の一般家庭向け防犯カメラ設置事例</h3>
            
            <div className="space-y-8">
              <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="grid grid-cols-1 lg:grid-cols-2">
                  <div className="bg-gray-100 p-8">
                    <div className="mb-4">
                      <span className="inline-block bg-gray-400 text-white px-4 py-2 rounded-full text-sm font-bold">Before</span>
                    </div>
                    <h4 className="text-xl font-bold text-gray-900 mb-4">留守中の見守り・安心</h4>
                    <p className="text-sm text-gray-600 mb-2">設置場所:一般家庭(玄関・リビング)</p>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-2">
                        <span className="text-gray-400 mt-1">•</span>
                        <span>留守中の来訪者が分からない</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-gray-400 mt-1">•</span>
                        <span>高齢の家族や子どもの様子が気になる</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-gray-400 mt-1">•</span>
                        <span>何かあった時に確認手段がない</span>
                      </li>
                    </ul>
                  </div>
                  <div className="bg-white p-8 border-l-4 border-teal-600">
                    <div className="mb-4">
                      <span className="inline-block bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-bold">After</span>
                    </div>
                    <h4 className="text-xl font-bold text-gray-900 mb-4">改善された状況</h4>
                    <div className="mb-4 relative">
                      <img src="https://public.readdy.ai/ai/img_res/0e774fd6355344003b9efa663c8a96e8.jpg" alt="留守中の見守り" className="w-full h-48 object-cover object-top rounded-lg" loading="lazy" decoding="async" width="600" height="192" />
                      <div className="mt-2 text-xs text-gray-500 text-center">※画像はイメージ画像です</div>
                    </div>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-teal-600 mt-1"></i>
                        <span>スマホで外出先から自宅の様子を確認できる</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-teal-600 mt-1"></i>
                        <span>来訪者や不審な動きにすぐ気づける</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-teal-600 mt-1"></i>
                        <span>「見える安心」で精神的な不安が軽減された</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                <div className="grid grid-cols-1 lg:grid-cols-2">
                  <div className="bg-gray-100 p-8">
                    <div className="mb-4">
                      <span className="inline-block bg-gray-400 text-white px-4 py-2 rounded-full text-sm font-bold">Before</span>
                    </div>
                    <h4 className="text-xl font-bold text-gray-900 mb-4">トラブル防止・証拠の確保</h4>
                    <p className="text-sm text-gray-600 mb-2">設置場所:一般家庭(駐車場・敷地内)</p>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-2">
                        <span className="text-gray-400 mt-1">•</span>
                        <span>車や敷地内のトラブルがあっても証拠が残らない</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <span className="text-gray-400 mt-1">•</span>
                        <span>近隣トラブル時に事実確認ができない</span>
                      </li>
                    </ul>
                  </div>
                  <div className="bg-white p-8 border-l-4 border-teal-600">
                    <div className="mb-4">
                      <span className="inline-block bg-teal-600 text-white px-4 py-2 rounded-full text-sm font-bold">After</span>
                    </div>
                    <h4 className="text-xl font-bold text-gray-900 mb-4">改善された状況</h4>
                    <div className="mb-4 relative">
                      <img src="https://readdy.ai/api/search-image?query=japanese%20residential%20parking%20area%20with%20security%20camera%20peaceful%20suburban%20neighborhood%20car%20parked%20safely%20modern%20home%20exterior%20simple%20clean%20background%20architectural%20photography&width=600&height=300&seq=parking-security-after-2&orientation=landscape" alt="トラブル防止" className="w-full h-48 object-cover object-top rounded-lg" loading="lazy" decoding="async" width="600" height="192" />
                      <div className="mt-2 text-xs text-gray-500 text-center">※画像はイメージ画像です</div>
                    </div>
                    <ul className="space-y-2 text-gray-700">
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-teal-600 mt-1"></i>
                        <span>映像で状況を確認でき、適切な指導が可能に</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <i className="ri-check-line text-teal-600 mt-1"></i>
                        <span>作業効率と安心感が向上した</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Us Section */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">京都・滋賀エリアで当社が選ばれる3つの理由</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-teal-50 to-cyan-50 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-56 overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/336c7154d263b703b5a7566b22f3169e.jpeg" 
                  alt="京都・滋賀での実績に基づいた格安提案" 
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  decoding="async"
                  width="400"
                  height="224"
                />
              </div>
              <div className="p-8">
                <div className="flex items-center justify-center mb-4">
                  <div className="w-16 h-16 flex items-center justify-center bg-white rounded-full shadow-md">
                    <i className="ri-lightbulb-line text-3xl text-teal-700"></i>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">格安で安心できる提案</h3>
                <p className="text-gray-700 leading-relaxed text-sm">
                  これまでの<strong>京都府・滋賀県</strong>での防犯カメラ設置経験をもとに、住環境や利用目的に合った格安プランをご提案。台数や設置位置を必要以上に増やさず、効果と費用のバランスを重視しています。
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-green-50 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-56 overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/969f21c7ce8a76c4a96f894c35a86273.jpeg" 
                  alt="柔軟な対応" 
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  decoding="async"
                  width="400"
                  height="224"
                />
              </div>
              <div className="p-8">
                <div className="flex items-center justify-center mb-4">
                  <div className="w-16 h-16 flex items-center justify-center bg-white rounded-full shadow-md">
                    <i className="ri-hand-heart-line text-3xl text-emerald-700"></i>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">お客様に寄り添った柔軟な対応</h3>
                <p className="text-gray-700 leading-relaxed text-sm">
                  市販カメラの持ち込み設置や、設置・設定作業のみのご依頼も承ります。「できるだけ格安で済ませたい」「必要な部分だけ頼みたい」といったご要望に柔軟に対応します。
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-56 overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/302d0795a6a1d1fcc316645cb2677273.jpeg" 
                  alt="京都・滋賀地域密着型サービス" 
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  decoding="async"
                  width="400"
                  height="224"
                />
              </div>
              <div className="p-8">
                <div className="flex items-center justify-center mb-4">
                  <div className="w-16 h-16 flex items-center justify-center bg-white rounded-full shadow-md">
                    <i className="ri-map-pin-user-line text-3xl text-cyan-700"></i>
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">京都・滋賀地域密着型の丁寧なサービス</h3>
                <p className="text-gray-700 leading-relaxed text-sm">
                  <strong>京都府・滋賀県</strong>を中心に現地確認を重視した地域密着型の格安防犯カメラ設置工事を実施。皆様のお役に立てるよう、一件一件の現場にしっかり向き合います。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Consultation Flow Section */}
        <section className="mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">京都・滋賀での防犯カメラ設置作業の流れ</h2>
          
          <div className="space-y-6">
            {[
              {
                step: '1',
                title: 'まずはお気軽にご相談ください',
                description: 'お客さまのお悩み事、ご依頼希望内容をご連絡ください。なお、京都府・滋賀県での防犯カメラ設置工事のお見積りやご相談は無料となっております。'
              },
              {
                step: '2',
                title: 'お客さまとのお打ち合わせ(現地調査)',
                description: '実際に京都府・滋賀県のお客さまの現地に訪問し、ご要望を1つ1つ丁寧にヒアリングし、防犯カメラ設置工事をについてお打ち合わせをさせていただきます。'
              },
              {
                step: '3',
                title: '提案内容の確認、見積の提出',
                description: 'お客さまにあった最適な防犯カメラ設置工事を提案し、お見積を提示いたします。また、スケジュールなども確認いたします。'
              },
              {
                step: '4',
                title: '防犯カメラ設置工事の実施',
                description: 'お客さまにご納得頂いた内容をもとに、京都府・滋賀県での防犯カメラ設置工事を実施します。'
              },
              {
                step: '5',
                title: 'アフターサポート',
                description: '弊社はお客さまが安心してご利用できるようにアフターフォロー体制も充実させています。防犯カメラ設置工事をした後の移設や撤去もお気軽にご相談ください。'
              }
            ].map((item, index) => (
              <div key={index} className="bg-white border-l-4 border-teal-600 p-6 rounded-lg shadow-sm">
                <div className="flex items-center gap-4 mb-3">
                  <span className="bg-teal-600 text-white w-12 h-12 rounded-full font-bold text-xl flex items-center justify-center flex-shrink-0">{item.step}</span>
                  <h3 className="text-lg font-bold text-gray-900">{item.title}</h3>
                </div>
                <p className="text-gray-700 leading-relaxed whitespace-pre-line">{item.description}</p>
              </div>
            ))}
          </div>
        </section>

        {/* FAQ Section */}
        <section id="faq-section" className="mb-16">
          <div className="mb-12">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">京都府・滋賀県で防犯に不安を感じ始めた方へ</h2>
            <p className="text-gray-700 text-center max-w-4xl mx-auto leading-relaxed mb-4">
              空き巣や不審者のニュースを目にする機会が増え、「うちも何か対策をしたほうがいいのでは」と感じている方が増えています。とはいえ、防犯対策は難しそう・高そうと感じ、後回しにしてしまう方も少なくありません。
            </p>
            <p className="text-gray-700 text-center max-w-4xl mx-auto leading-relaxed">
              このQ＆Aでは、<strong>京都府・滋賀県</strong>の一般家庭向けに、できるだけ分かりやすく、防犯カメラ設置対策についてまとめています。
            </p>
          </div>

          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">京都・滋賀の防犯カメラ設置に関するよくあるご質問(Q＆A)</h3>
          
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                <button
                  onClick={() => toggleFaq(index)}
                  className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <span className="font-bold text-gray-900 pr-4">{faq.question}</span>
                  <i className={`ri-add-line text-2xl text-red-600 flex-shrink-0 transition-transform ${openFaqIndex === index ? 'rotate-45' : ''}`}></i>
                </button>
                {openFaqIndex === index && (
                  <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
                    <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-100 pt-12 pb-6">
        <div className="max-w-7xl mx-auto px-4 mb-12">
          <div className="bg-white p-6 rounded-lg flex items-center justify-center gap-6">
            <i className="ri-map-pin-line text-4xl text-red-600"></i>
            <div>
              <div className="font-bold text-lg">格安防犯カメラ設置 ご対応エリア</div>
              <div className="text-gray-700"><strong>京都府・滋賀県</strong></div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 mb-12">
          <div className="grid grid-cols-1 gap-4">
            <div className="bg-red-600 text-white p-6 rounded-lg flex items-center justify-center gap-4">
              <i className="ri-phone-line text-3xl"></i>
              <div>
                <a
                  href="tel:08025278110"
                  className="text-2xl font-bold text-white"
                  style={{ textDecoration: 'none' }}
                >
                  TEL. 080-2527-8110
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 pt-8 border-t border-gray-300">
          <div className="flex flex-col lg:flex-row justify-between gap-8 mb-8">
            <div>
              <Link to="/company#company-info" className="inline-block mb-4 hover:opacity-80 transition-opacity">
                <div className="flex items-center gap-2">
                  <img 
                    src="https://static.readdy.ai/image/f1769650ef219847a82938b2ccb51dd4/b20bf12da98b13bf6586d3e638cf3b35.jpeg" 
                    alt="Next stage ロゴ" 
                    className="h-8 w-auto object-contain"
                    loading="lazy"
                    decoding="async"
                    width="80"
                    height="32"
                  />
                  <div className="text-2xl font-bold text-teal-700">Next stage（ネクストステージ）</div>
                </div>
              </Link>
              <div className="text-sm text-gray-600">京都・滋賀の格安防犯カメラ設置で、家族と店舗に確かな安心を</div>
              <div className="text-sm text-gray-600">
                〒542-0083 大阪府大阪市中央区東心斎橋１丁目９-１４-３０７<br />
                <a
                  href="tel:08025278110"
                  className="text-gray-600"
                  style={{ textDecoration: 'none' }}
                >
                  TEL 080-2527-8110
                </a>
              </div>
            </div>
            <nav className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
              <a href="#use-cases" className="hover:text-red-600 whitespace-nowrap cursor-pointer">防犯カメラ活用事例</a>
              <a href="#faq-section" className="hover:text-red-600 whitespace-nowrap cursor-pointer">防犯に不安を感じ始めた方へ</a>
              <Link to="/company#company-info" className="hover:text-red-600 whitespace-nowrap">会社概要</Link>
            </nav>
          </div>
          <div className="text-center text-sm text-gray-600 pt-4 border-t border-gray-300">
            © 2025 京都・滋賀の格安防犯カメラ設置工事サービス　ネクストステージ　｜　<a href="https://readdy.ai/?ref=logo" rel="nofollow" className="hover:underline">Website Builder</a>
          </div>
        </div>
      </footer>
    </div>
  );
}
